/** Display-only citation: never change persisted labels or row identities. */
export const formatLedgerRangeCitation = (first: string, last: string): string => {
  const parse = (label: string) => /^([A-Za-z]+)[.-]\s*(\d+)$/.exec(label)
  const start = parse(first)
  const end = parse(last)
  if (!start || !end || start[1] !== end[1]) return first === last ? first : `${first}–${last}`
  const citation = `${start[1]}. ${start[2].padStart(3, '0')}`
  return first === last ? citation : `${citation}–${end[2].padStart(3, '0')}`
}
